export const RECYCLE_DEVICE_TITLE =
  'Are you sure you want to recycle this device?';

export const RECYCLE_DEVICE_SUBTITLE =
  'Your device will be actioned to be recycled immediately and cannot be cancelled. Your certificate of erasure will be provided after recycle. Please note, there is a $40 fee for each device recycled.';

export const SAVE_BUTTON_COPY = 'Yes, recycle';
